import React,{useEffect,useRef} from 'react';
import {defaultTheme} from '@ibibo/build-theme';

import * as S from './OfferCarouselUI.styles';

import LeftArrowNewIcon from '../../../../Icons/ArrowLeftNew';
import RightArrowNewIcon from '../../../../Icons/ArrowRightNew';

import useCarousel from '../../../../../shared/hooks/useCarousel';

const OfferCarouselUI = ({
  dataFromState,
  actionHandler,
}) => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
  } = useCarousel(dataFromState, 3);

  const shouldIncrement = useRef(true);

  useEffect(() => {
    let id = setTimeout(() => {
        if (isRightCursorActive && !isLeftCursorActive) { {increment();shouldIncrement.current =true}}
        else if (!isRightCursorActive && isLeftCursorActive) { {decrement();shouldIncrement.current=false}}
        else {

            if (shouldIncrement.current ) {
                increment()
            }else {
                decrement()
            }
        }
    }, 6000);
      return () => clearTimeout(id);
  },)

        // made 2 since we've only have 2 items and it is fixed for now
      // Also arrows are removed from the offer corousel. No sliding atleast until we stop hard coding offers

      return (

    <S.SpecialOfferMainWrap >
      <S.SpecialOfferHeaderWrap>
          <S.SpecialOfferHeadText>Special Offers</S.SpecialOfferHeadText>

          {<S.SplOfferCaroIconWrap>
              <S.IconInnerWrapCaro>
                  <S.LeftIconWrapCaro
                    onClick={decrement}
                    disabled={!isLeftCursorActive}
                  >
                    <LeftArrowNewIcon width="1.3rem" height="1.3rem" fill={!isLeftCursorActive ? defaultTheme.colors.grey.lightc2 : ''} />
                  </S.LeftIconWrapCaro>

                  <S.RightIconWrapCaro
                    onClick={increment}
                    disabled={!isRightCursorActive}
                  >
                    <RightArrowNewIcon width="1.3rem" height="1.3rem" fill={!isRightCursorActive ? defaultTheme.colors.grey.lightc2 : ''} />
                  </S.RightIconWrapCaro>
              </S.IconInnerWrapCaro>
          </S.SplOfferCaroIconWrap> }

      </S.SpecialOfferHeaderWrap>

      <S.SpecialOfferCaroOuterWrap customMargin={false}>
          <S.SpecailOfferCaroInnerWrap>
            {dataList.map(
              item =>
                (item.sub_heading && item.img_url && (
                  <S.SpecialOfferCaroList disabled={item.url===''}  key={'offerCaro' + item.sub_heading}
                    onClick={() => {
                      if (item.url) {
                        actionHandler(item.url);
                      }
                    }}>
                      <S.SpecialOfferCardInfoWrap>

                          <S.CaroCardLeftBlock>
                            <S.SpecialOfferImgWrap>
                              <S.SpecialOfferCaroImg src={item.img_url} alt={item.sub_heading}/>
                            </S.SpecialOfferImgWrap>
                            {item.validity_text ? <S.OfferVaildTextWrap>
                              <S.OfferValidText>Valid till: {item.validity_text}</S.OfferValidText>
                            </S.OfferVaildTextWrap> : null}
                            <S.TnCTextWrap>
                              <S.TnCText>T&C Apply</S.TnCText>
                            </S.TnCTextWrap>
                          </S.CaroCardLeftBlock>

                          <S.CaroCardRightBlock>
                            {/* <S.DestTypeWrap>
                              <S.DestTypeText>Domestic</S.DestTypeText>
                            </S.DestTypeWrap> */}
                            <S.OfferTextWrap>
                              <S.OfferText>{item.sub_heading}</S.OfferText>
                            </S.OfferTextWrap>
                            <S.SmallBorderBlock />
                            {/* <S.OfferDetailWrap>
                              <S.offerDetailText><span>100% Moneyback Guarantee </span>if you cancel your ticket @ Rs.379 only</S.offerDetailText>
                            </S.OfferDetailWrap> */}
                          </S.CaroCardRightBlock>

                          {/* <S.SplMadeTag>
                            <S.SpLmadeTagText>Made Specially for You</S.SpLmadeTagText>
                          </S.SplMadeTag> */}

                      </S.SpecialOfferCardInfoWrap>
                  </S.SpecialOfferCaroList>
                )) ||
                null,
            )}
          </S.SpecailOfferCaroInnerWrap>
      </S.SpecialOfferCaroOuterWrap>
    </S.SpecialOfferMainWrap>
  );
};

export default OfferCarouselUI;
